export const userQueryKeys = {
  all: ['users'] as const,
} as const;
